// extracted by mini-css-extract-plugin
module.exports = {"login_box":"Login_login_box__1pPYH","login_form":"Login_login_form__2EQDn"};